module.exports = __webpack_public_path__ + "img/inspiration-2.e3d846b.jpg";